module.exports = __webpack_public_path__ + "media/Group2.3baf07d9.mp3";